<template>
  <div class="page-container">

    
    <div class="main-content">
      <main class="content-area">
        
        <div v-if="reviewContent" class="api-content">
          <div class="content-card">
            <h3 class="content-title">{{ reviewTitle || '军队院校招收学员政治考核指南' }}</h3>
            <div class="content-body" v-html="reviewContent"></div>
          </div>
        </div>
        
        <div v-else class="loading-state">
          <div class="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { getPoliticalGuide } from "@/api/processApi";
import { baseURL } from "@/api/axiosConfig";

export default {
  name: "PoliticalReview",
  data() {
    return {
      reviewTitle: '',
      reviewContent: ''
    };
  },
  mounted() {
    this.fetchPoliticalGuide();
  },
  methods: {
    addImageBaseUrl(content) {
      if (!content) return "";
      return content.replace(/<img[^>]+src="\/(dev-api\/)?profile\/upload\/[^"]+"/g, (match) => {
        return match.replace(/src="\/(dev-api\/)?profile\/upload\//, `src="${baseURL}/profile/upload/`);
      });
    },
    
    fetchPoliticalGuide() {
      getPoliticalGuide().then(response => {
        if (response.data.code === 200) {
          const data = response.data.data;
          this.reviewTitle = data.title || '军队院校招收学员政治考核指南';
          this.reviewContent = this.addImageBaseUrl(data.pdfurl) || '';
        }
      }).catch(error => {
        console.error('获取政审指南失败:', error);
      });
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  margin-top: 60px;
  padding: 0 10px 10px;
  background: linear-gradient(135deg, #fff3e0 0%, #f0f4f8 100%);
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.page-title {
  font-size: 32px;
  color: #f57c00;
  margin: 0 0 8px 0;
  font-weight: bold;
}

.page-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.main-content {
  max-width: 1440px;
  margin: 0 auto;
}

.content-area {
  width: 100%;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 20px;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f0f0f0;
  border-top-color: #f57c00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-state p {
  font-size: 16px;
  color: #999;
  margin: 0;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 26px;
  }
  
  .content-title {
    font-size: 18px;
  }
}

.api-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.content-card .content-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 16px 0;
  font-weight: 600;
  text-align: center;
}

.content-body {
  font-size: 15px;
  color: #333;
  line-height: 1.8;
}

.content-body h4 {
  font-size: 16px;
  color: #f57c00;
  margin: 20px 0 10px 0;
  font-weight: 600;
}

.content-body p {
  margin: 0 0 12px 0;
}

.content-body ul, .content-body ol {
  margin: 0 0 12px 20px;
  padding: 0;
}

.content-body li {
  margin-bottom: 8px;
}
</style>